import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Category extends Component {

  state = {
    category: [],
    load: false,
  }

  componentDidUpdate(props) {
    if (props.data != this.props.data) {
      this.setCategory();
      this.selected();
    }
  }

  add(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Adding category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addsparecategory.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  remove(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Removing category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/removesparecategory.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setCategory() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'category') {
        model.push({key: y.name, text: y.name, value: y.name});
      }
    });
    context.setState({
      categoryOption: model,
    });
  }

  selected() {
    let context = this;
    var category = [];
    this.props.data.map((y) => {
      if (y.type == 'selectedcategory') {
        category.push(y.name);
      }
    });
    context.setState({
      category: category,
    });
  }

  check(value) {
    let oldValue = this.state.category;
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      for (var i = 0; i < oldValue.length; i++) {
        if (length == 0) {
          this.remove(oldValue[i]);
          return;
        }
        for (var j = 0; j < length; j++) {
          if (oldValue[i] != value[j]) {
            this.remove(oldValue[i]);
            return;
          }
        }
      }
    }
  }

  Category = (f, { value }) => {
    this.check(value);
    this.setState({ category: value })
  }

  render() {
    let { category } = this.state;
    let { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
      <Dropdown fluid placeholder='Category' style={{ borderColor: '#5A9CBB' }}
       multiple search selection onChange={this.Category}
       options={this.state.categoryOption} value={category} />
       {loading}
      </div>
    );
  }
}

export default Category;
